import {
  TabPanel,
  Button,
  LoadPanel,
  TextArea,
  DateBox,
} from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Projects.scss";

import ProjectsTab from "./ProjectsTab/ProjectsTab";
import ProjectCategoryTab from "./ProjectCategoryTab/ProjectCategoryTab";

import CustomSlider from "../../components/customSlider/CustomSlider";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import CustomDropdown from "../../components/customDropDown/CustomDropdown";
import CustomButton from "../../components/customButton/CustomButton";

import { postSubCategories, getCategoryData } from "../../api/settingsApi";

import { useAuth } from "../../contexts/auth";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";

export default function Projects() {
  const { user } = useAuth();
  const location = useLocation();
  const [loading] = useState(false);
  const [activeTab, setActiveTab] = useState(location.state?.tabIndex ?? 0);
  const [reloadProjects, setReloadProjects] = useState(false);

  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isSlidingOut, setIsSlidingOut] = useState(false);

  const [newProject, setNewProject] = useState("");
  const [description, setDescription] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCategories] = useState([]);

  const [accessDeadline, setAccessDeadline] = useState(null);
  const [accessStart, setAccessStart] = useState(null);

  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    if (isDrawerOpen === true) {
      fetchCategories();
    }
  }, [isDrawerOpen]);

  useEffect(() => {
    if (location.state?.tabIndex !== undefined) {
      setActiveTab(location.state.tabIndex);
    }
  }, [location.state]);

  const fetchCategories = async () => {
    const response = await getCategoryData();
    setCategories(
      response?.data?.map((cat) => ({
        value: cat.transid,
        text: cat.ticketcategoryname,
      })),
    );
  };

  const openDrawer = () => {
    setNewProject("");
    setDescription("");
    setSelectedCategory(null);
    setAccessStart(null);
    setAccessDeadline(null);
    setIsSlidingOut(false);
    setDrawerOpen(true);
  };
  const closeDrawer = () => {
    setIsSlidingOut(true);
  };

  const saveProject = async () => {
    //validation
    if (!newProject || !newProject.trim()) {
      ToastDisplayer("error", "Category name is required");
      return;
    }

    if (!selectedCategory) {
      ToastDisplayer("error", "Project is required");
      return;
    }

    if (accessStart && !accessDeadline) {
      ToastDisplayer("error", "End time is required");
      return;
    }
    if (accessStart && accessDeadline && accessDeadline <= accessStart) {
      ToastDisplayer("error", "End time must be greater than start time");

      return;
    }
    // const formatDateTime = (date) => {
    //   if (!date) return null;
    //   return date.toISOString().slice(0, 19);
    // };
    const formatDateTime = (date) => {
      if (!date) return null;

      const pad = (n) => n.toString().padStart(2, "0");

      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        "T" +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    };
    const payload = {
      ticketsubcatname: newProject,
      description: description,
      ticketsubiddeleted: 0,
      companytransid: user.companytransid,
      ticketcategorytransid: selectedCategory,
      access_start: formatDateTime(accessStart),
      access_deadline: formatDateTime(accessDeadline),
    };

    try {
      const result = await postSubCategories(payload);

      ToastDisplayer("success", result.message);

      setDrawerOpen(false);

      // trigger refresh
      setReloadProjects((prev) => !prev);
    } catch (error) {
      ToastDisplayer("error", error.message);
    }
  };
  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="ProjectPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span className="icon-size">
                <i className="ri-folder-3-line"></i>
              </span>
              <p>Projects</p>
            </div>
          </div>

          <div className="headerContainer2">
            {activeTab === 1 && (
              <Button
                className="addBtn"
                icon="add"
                text="Add Category"
                type="default"
                onClick={openDrawer}
              />
            )}
          </div>
        </div>

        <div className="settingsMain">
          <TabPanel
            className="projectTabs"
            animationEnabled={true}
            swipeEnabled={!isMobile ? true : false}
            // deferRendering={false}
            defaultSelectedIndex={0} // initial tab
            // selectedIndex={activeTab}
            onSelectionChanged={(e) =>
              setActiveTab(e.component.option("selectedIndex"))
            }
          >
            <Item title="Project">
              <div className="innerTab">
                <ProjectCategoryTab />
              </div>
            </Item>
            <Item title="Project Category">
              <div className="innerTab">
                <ProjectsTab reloadProjects={reloadProjects} />
              </div>
            </Item>
          </TabPanel>
        </div>

        {/* ADD PROJECT DRAWER */}

        <CustomSlider
          isOpen={isDrawerOpen}
          isSlidingOut={isSlidingOut}
          onClose={closeDrawer}
          headtext={"Add Category"}
          setSliderOpen={setDrawerOpen}
          setIsSlidingOut={setIsSlidingOut}
        >
          <div className="drawerContainer">
            {/* BODY */}
            <div className="drawerBody">
              <div className="drawerTitle">All Details</div>

              <div className="drawerRow">
                <CustomTextBox
                  label="Enter Category Name "
                  placeholder="Category Name"
                  value={newProject}
                  onChange={(e) => setNewProject(e.value)}
                />

                <CustomDropdown
                  label="Project "
                  placeholder="Select Project"
                  myDataSource={categories}
                  value={selectedCategory}
                  setSelectedValue={(val) => setSelectedCategory(val?.value)}
                />
              </div>
              <div className="drawerRow">
                <div className="MyTextBox">
                  <label className="TextBoxLabel">Start Date and Time</label>
                  <DateBox
                    type="datetime"
                    placeholder="Select Date and Time"
                    width="100%"
                    value={accessStart}
                    pickerType="calendar"
                    stylingMode="outlined"
                    min={new Date()} //ONLY future dates allowed
                    displayFormat="dd-MM-yyyy HH:mm"
                    onValueChanged={(e) => setAccessStart(e.value)}
                  />
                </div>
                <div className="MyTextBox">
                  <label className="TextBoxLabel">End Date and Time</label>
                  <DateBox
                    type="datetime"
                    placeholder="Select Date and Time"
                    width="100%"
                    value={accessDeadline}
                    pickerType="calendar"
                    stylingMode="outlined"
                    min={accessStart || new Date()}
                    displayFormat="dd-MM-yyyy HH:mm"
                    onValueChanged={(e) => setAccessDeadline(e.value)}
                  />
                </div>
              </div>

              <div className="drawerTextarea">
                <label className="drawerLabel">Description</label>

                <TextArea
                  value={description}
                  stylingMode="outlined"
                  placeholder="Enter Description"
                  height={120}
                  onValueChanged={(e) => setDescription(e.value)}
                />
              </div>
            </div>

            {/* FOOTER */}
            <div className="drawerFooter">
              <Button
                height={40}
                text="Cancel"
                stylingMode="outlined"
                onClick={closeDrawer}
              />

              <Button
                className="saveBtn"
                height={40}
                text="Save Details"
                stylingMode="outlined"
                onClick={saveProject}
              />

              {/* <CustomButton text="Save Details" onClick={saveProject} /> */}
            </div>
          </div>
        </CustomSlider>
      </div>
    </>
  );
}
